import { SplittenMengeKorrekturItemResponse } from '@/types/service-response'
import moment from 'moment'

export class ProjectBookingMengen {
  public constructor (
    readonly Selektiert: boolean,
    readonly Zeile: number | null,
    readonly Bezeichnung: string | null,
    readonly SollMenge: number | null, //double
    readonly IstMenge: number | null, //double
    readonly Verfuegbar: number | null, //double
    readonly Bestand: number | null, //double
    readonly InKommissionierung: number | null,
    readonly Gesperrte: number | null,
    readonly Reserviert: number | null, //double
    readonly Bestellt: number | null, //double
    readonly EinheitCode: number,
    readonly SplittErlaubt: boolean,
    readonly Splitten: boolean,
    readonly RestDatum: string | null,
    readonly TerminArt: boolean
  ) {}

  static createFromResponse (responseData: SplittenMengeKorrekturItemResponse[]): Array<ProjectBookingMengen> {
    let result: Array<ProjectBookingMengen> = []
    if (responseData) {
      result = responseData.map((item: SplittenMengeKorrekturItemResponse) => {
        return new ProjectBookingMengen(
          item.Selektiert,
          item.Zeile,
          item.Bezeichnung,
          item.SollMenge !== null ? parseFloat(item.SollMenge.toFixed(3)) : null,
          item.IstMenge!== null ? parseFloat(item.IstMenge.toFixed(3)) : null,
          item.Verfuegbar !== null ? parseFloat(item.Verfuegbar.toFixed(3)) : null,
          item.Bestand !== null ? parseFloat(item.Bestand.toFixed(3)) : null,
          item.InKommissionierung,
          item.Gesperrte,
          item.Reserviert !== null ? parseFloat(item.Reserviert.toFixed(3)) : null,
          item.Bestellt !== null ? parseFloat(item.Bestellt.toFixed(3)) : null,
          item.EinheitCode,
          item.SplittErlaubt,
          item.Splitten,
          item.RestDatum ? moment(item.RestDatum).format('DD.MM.YYYY') : null,
          item.TerminArt
        )
      })
    }
    return result
  }
}
